import React, { useEffect } from 'react';
import { TabOptions } from '../../../../../../../cronGeneratorState/cronGeneratorContext';
import { Radio } from 'antd';
import Text from 'components/Text/Text';
import style from './EveryOption.module.scss';

interface IEveryOption {
	onSetResult: (value: string) => void;
}

const EveryOption: React.FC<IEveryOption> = ({ onSetResult }) => {
	const handleCheck = () => {
		const everyResult = '*';
		onSetResult(everyResult);
	};

	useEffect(() => {
		handleCheck();
	}, []);

	return (
		<div className={style.radioField}>
			<Radio value={TabOptions.EVERY_OPTION} id={TabOptions.EVERY_OPTION + 'monthTab'} onChange={handleCheck} />
			<label className={style.label} htmlFor={TabOptions.EVERY_OPTION + 'monthTab'}>
				<Text translationNameSpace="form" translationKey="everyMonthLabel" asFragment={true} />
			</label>
		</div>
	);
};

export default React.memo(EveryOption);
